<template>
  <router-view/>
</template>

<script>
export default {
  name: 'App',
  data: () => ({
    //
  })
}
</script>
<style>
/* main.v-main{
  padding: 0px 0px 0px !important;
} */
</style>
